import { Component, Input, OnInit } from '@angular/core'
import { FormAtylBase } from '../../../../form-atyl-base'


@Component({
	selector: 'atyl-form-input-label',
	templateUrl: './form-input-label.component.html',
	styleUrls: ['./form-input-label.component.scss']
})
export class FormInputLabelComponent implements OnInit {

	@Input() forminput: FormAtylBase<any>
	@Input() disabled: boolean


	ngOnInit(): void {
		
		console.log("FormInputLabelComponent",this.forminput)
	}
}
